import * as React from 'react';
import { Helmet } from 'react-helmet';

export function PageTitle({ titleString }: { titleString: string }) {
  return <Helmet title={titleString} />;
}
